import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDashboard, fetchDashboardDrilldown, fetchDashboardDrilldownV2, fetchDashboardV2 } from '../fetch/dashboard';
import { JSON_PARSE_ERROR } from './consts';

export const getDashboard = createAsyncThunk(
  'dashboard/getDashboardStatus',
  ({ dashboard }, { rejectWithValue }) => fetchDashboard(dashboard)
      .then(({ data }) => ({ dashboard: data }))
      .catch((err) => rejectWithValue({ error: err })),
);

export const getDashboardV2 = createAsyncThunk(
  'dashboard/getDashboardStatus',
  ({ type, dashboard }, { rejectWithValue }) => fetchDashboardV2(type, dashboard)
      .then(({ data }) => ({ dashboard: data }))
      .catch((err) => rejectWithValue({ error: err })),
);

export const getDashboardDrilldown = createAsyncThunk(
  'dashboard/getDashboardDrilldownStatus',
  ({ dashboard, query }, { rejectWithValue, fulfillWithValue }) => {
    const meta = { dashboard };
    return fetchDashboardDrilldown(dashboard, query)
      .then(({ data }) => fulfillWithValue({ dashboard: data }, meta))
      .catch((err) => rejectWithValue({ error: err }, meta));
  },
);

export const getDashboardDrilldownV2 = createAsyncThunk(
  'dashboard/getDashboardDrilldownStatus',
  ({ type, dashboard, query }, { rejectWithValue, fulfillWithValue }) => {
    const meta = { dashboard };
    return fetchDashboardDrilldownV2(type, dashboard, query)
      .then(({ data }) => fulfillWithValue({ dashboard: data }, meta))
      .catch((err) => rejectWithValue({ error: err }, meta));
  },
);


const initialState = {
  isLoading: {},
  dashboards: {},
  isDrilldownLoading: {},
  drilldowns: {},
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: {
    [getDashboard.pending]: (state, { meta: { arg } }) => {
      state.isLoading[arg.dashboard] = true;
    },
    [getDashboard.fulfilled]: (state, { payload: { dashboard }, meta: { arg } }) => {
      state.dashboards[arg.dashboard] = dashboard;
      state.isLoading[arg.dashboard] = false;
    },
    [getDashboard.rejected]: (state, { payload: { error }, meta: { arg } }) => {
      state.dashboards[arg.dashboard] = { error: error.message === JSON_PARSE_ERROR ? 'Error loading dashboard data!' : error.message };
      state.isLoading[arg.dashboard] = false;
    },
    [getDashboardDrilldown.pending]: (state, { meta: { arg } }) => {
      state.isDrilldownLoading[arg.dashboard] = true;
    },
    [getDashboardDrilldown.fulfilled]: (state, { payload: { dashboard }, meta: { arg } }) => {
      state.drilldowns[arg.dashboard] = dashboard;
      state.isDrilldownLoading[arg.dashboard] = false;
    },
    [getDashboardDrilldown.rejected]: (state, { payload: { error }, meta: { arg } }) => {
      state.drilldowns[arg.dashboard] = { error: error.message === JSON_PARSE_ERROR ? 'Error loading drilldown data!' : error.message };
      state.isDrilldownLoading[arg.dashboard] = false;
    },
  },
});

export default dashboardSlice.reducer;
